import SharedVideo from "@/components/shared/VideoConference";
export default function BrokerVideo() {
  return <SharedVideo role="broker" />;
}
